import { useState } from 'react';
import { useEffect } from 'react';
import { InputDate } from '../theme/Input/InputDate';
import { BasicButton } from '../theme/Component/BasicButton';

interface Props {
    supplier: any;
    formSupplier: any;
    updateInfo: Function;
}
export const Consultalistas = ({ supplier, formSupplier, updateInfo }: Props) => {

    const [formulario, setFormulario] = useState<any>({});

    useEffect(() => {
        if (formSupplier.forma7 === undefined)
            formSupplier.forma7 = {};
        setFormulario(formSupplier.forma7);
    }, [formSupplier])

    const updateConsentimiento = () => {
        let temp: any = formSupplier;
        formulario.state = true;
        temp.forma7 = formulario;
        ////console.log(temp);

        updateInfo(temp);
    }

    return (
        <>
            <h5 className='titul-form' style={{ textAlign: 'center' }}>Consulta Listas Vinculantes y Verificación de Información - USO EXLCUSIVO CAJA HONOR</h5>
            <hr />
            <div className="row">
                <div className="col-md-6">
                    <label className='titul-form'>Nombre Completo del funcionario:</label>
                    <input type="text" className='form-control' value={formulario.nombrefuncio} onChange={(e) => setFormulario({ ...formulario, "nombrefuncio": e.target.value })} />
                </div>
                <div className="col-md-6">
                    <label className='titul-form'>No. Cedula de Ciudadania del funcionario:</label>
                    <input type="number" className='form-control' value={formulario.ciudadfuncionario} onChange={(e) => setFormulario({ ...formulario, "ciudadfuncionario": e.target.value })} />
                </div>
                <div className="col-md-6">
                    <label className='titul-form'>Fecha de consulta - dd/mm/año</label>

                    <InputDate name='f1' label='' value={formulario.fechacreacion} setDate={(e: any) => setFormulario({ ...formulario, "fechacreacion": e })} />
                </div>
            </div>
            <div className="col-md-12">
                <BasicButton icon='ri-save-3-line' eventClick={updateConsentimiento}>Guardar</BasicButton>
            </div>
            {/* <PrintJson json={formulario}/>
            <PrintJson json={supplier}/> */}
        </>
    )
}